@if (corporateTaxEntity$ | async; as corporateTaxEntity) {
  <form [formGroup]="agrarischFg" (change)="saveForm()">
    <div class="row">
      <div class="col-7">
        <p>Verricht {{ corporateTaxEntity.aangifte?.identificatie?.naamLichaam }} agrarische activiteiten?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="agrarischeActiviteiten"
                                          id="agrarischeActiviteiten"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>
  </form>
  <form [formGroup]="algemeenFg" (change)="saveForm()">
    <div class="row">
      <div class="col-7">
        <p>Wordt de aangifte in functionele valuta gedaan?</p>
      </div>
      <div class="col-5">
        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                          class="custom-input-150"
                                          formControlName="regelingFunctioneleValuta"
                                          id="regelingFunctioneleValuta"
        >
        </snelstart-ui-select-form-control>
      </div>
    </div>

    <div>

      <div class="row">
        <div class="col-7">
          <p>Wordt er gebruik gemaakt van de innovatiebox?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="gebruikInnovatiebox"
                                            id="gebruikInnovatiebox"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Zijn de activiteiten gewijzigd in het boekjaar?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="activiteitenOndernemingGewijzigd"
                                            id="activiteitenOndernemingGewijzigd"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is het waarderingsstelsel gewijzigd in het boekjaar?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="wijzigingWaarderingsstelsel"
                                            id="wijzigingWaarderingsstelsel"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is er willekeurig afgeschreven in het boekjaar?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="willekeurigAfschijven"
                                            id="willekeurigAfschijven"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is er een pensioenregeling gewijzigd in het boekjaar?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="nieuweOfGewijzigdePensioenregeling"
                                            id="nieuweOfGewijzigdePensioenregeling"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is de verdeling van het aandelenkapitaal gewijzigd?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="verdelingAandelenkapitaalGewijzigd"
                                            id="verdelingAandelenkapitaalGewijzigd"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is er sprake van een earn out regeling?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="earnOutRegeling"
                                            id="earnOutRegeling"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Wordt er een beroep gedaan op de tegenbewijsregeling voor renteaftrek?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="toepassingTegenbewijsRenteaftrek"
                                            id="toepassingTegenbewijsRenteaftrek"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Zijn er rechtshandelingen met een buitenlandse aandeelhouder verricht?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="rechtshandelingenMetBuitenlandseAandeelhouders"
                                            id="rechtshandelingenMetBuitenlandseAandeelhouders"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is er een belang in fiscaal transparante entiteiten?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="belangInFiscaalTransparanteEntiteit"
                                            id="belangInFiscaalTransparanteEntiteit"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>


      <div class="row">
        <div class="col-7">
          <p>Is er vermogen afgezonderd in een 'Afgezonderd Particulier Vermogen' (APV)?</p>
        </div>
        <div class="col-5">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-150"
                                            formControlName="vermogenAfgezonderdInApv"
                                            id="vermogenAfgezonderdInApv"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>

    </div>
  </form>
}


